import React from "react"
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from "@mui/material"
import { Translate } from "utils/i18n-shim"

import { FlagIcon } from "shared/ui/berry-jass"
import useLocale from "hooks/useLocale"
import { getProductNameByLocale } from "../lib"

export const ProductsTable = ({ data }) => {
  const locale = useLocale()

  if (!data || data.length === 0) {
    return null
  }

  return (
    <TableContainer
      component={Paper}
      sx={{
        width: "calc(100vw - 120px)",
        border: 1,
        my: 0.75,
        borderColor: "#DFDFDF"
      }}
    >
      <Table>
        <TableHead>
          <TableRow>
            <TableCell size="small">
              <Translate value="suppliers.name.title" />
            </TableCell>
            <TableCell size="small">
              <Translate value="name" />
            </TableCell>
            <TableCell size="small">
              <Translate value="type" />
            </TableCell>
            <TableCell size="small">
              <Translate value="products.runtime-in-days.title" />
            </TableCell>
            <TableCell size="small">
              <Translate value="id" />
            </TableCell>
            <TableCell size="small">
              <Translate value="country" />
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((sales_product) => (
            <TableRow key={sales_product.id}>
              <TableCell size="small">
                <Box display="flex" flexDirection="row" alignItems="center">
                  <Box width={140} height={32}>
                    <img
                      height="32"
                      src={sales_product.logo}
                      loading="lazy"
                      alt="logo"
                    />
                  </Box>
                  <Typography variant="h6">
                    {sales_product.supplier_name || (
                      <Translate value="sales-products-new.no-supplier" />
                    )}
                  </Typography>
                </Box>
              </TableCell>
              <TableCell size="small">
                <Typography variant="subtitle2">
                  {getProductNameByLocale(sales_product, locale)}
                </Typography>
              </TableCell>
              <TableCell size="small">
                <Typography variant="subtitle2">
                  {sales_product.type}
                </Typography>
              </TableCell>
              <TableCell size="small">
                <Typography variant="subtitle2">
                  <Translate
                    value="plurals.days"
                    count={sales_product.runtime_in_days}
                  />
                </Typography>
              </TableCell>
              <TableCell size="small">
                <Typography variant="subtitle2">{sales_product.id}</Typography>
              </TableCell>
              <TableCell size="small">
                <Typography variant="subtitle2">
                  {sales_product.country_list?.map((country) => (
                    <FlagIcon key={country} countryCode={country} />
                  ))}
                </Typography>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
